import mapFns from "./map";
import argParser from "./argParser";
import "./elementCreator";
import dok from "./plugins/DOKPlugin";
import global from "./globals";
import creator from "./elementCreator";
import Feature from "ol/Feature";
import Draw from "ol/interaction/Draw.js";
import Point from "ol/geom/Point";
import Style from "ol/style/Style.js";
import Icon from "ol/style/Icon.js";
import Stroke from "ol/style/Stroke.js";
import Vector from "ol/layer/Vector.js";
import VectorWMS from "ol/source/Vector.js";
import Circle from "ol/style/Circle.js";
import Fill from "ol/style/Fill.js";
var userTips, giHint, privateFns;

privateFns = {
  setSiteAttributes: function (params) {
    var target = $(".site-name");
    if (params.title) {
      target.find("h1").html(params.title);
    } else {
      target.find("h1").html("planinnsyn");
    }
    if (params.subTitle) {
      target
        .find("h1")
        .addClass("subTitle")
        .after("<br /><span>" + params.subTitle + "</span>");
    }
    if (params.customClass) {
      target.addClass(params.customClass);
    }
    if (params.titleLink) {
      $("#titleLink")[0].href = params.titleLink;
    }
  },
  setColorScheme: function (colors) {
    if (colors) {
      Object.keys(colors).forEach(function (key) {
        document.documentElement.style.setProperty("--" + key, colors[key]);
      });
    }
    var img = document.getElementById("osloLogo");
    img.src =
      "./img/" +
      window
        .getComputedStyle(document.documentElement)
        .getPropertyValue("--logo")
        .split("#")[1] +
      ".png";
  },
};
userTips = {
  showTipWin: function (tipText, tipId) {
    //var tipWin, btnWrapper, okBtn, inputWrapper, hideId = "", hideLabel, hideInput, article;

    var tipWin = creator.createDiv({ css: "tip-win blueTip" });
    var closeBtn = creator.createButton({
      css: "btn btn-default close",
      text: "<i class = 'icon-Close'></i>",
    });
    closeBtn.style.opacity = 1;
    closeBtn.style.color = "white";
    closeBtn.onclick = function () {
      $(tipWin).remove();
    };
    tipWin.appendChild(closeBtn);
    var article = creator.createArticle({});
    var hideId = tipId;
    if (
      localStorage.getItem("planinnsyn-" + hideId) === null &&
      global.mapMode !== "kommuneplan"
    ) {
      article.appendChild(creator.createSection({ text: tipText }));
    }
    tipWin.appendChild(article);

    var btnWrapper = creator.createDiv({ css: "tip-win-btn-wrapper" });
    var okBtn = creator.createButton({ css: "btn btn-default", text: "OK" });
    okBtn.onclick = function () {
      $(tipWin).remove();
    };
    btnWrapper.appendChild(okBtn);
    tipWin.appendChild(btnWrapper);

    var inputWrapper = creator.createDiv({ css: "tip-win-input-wrapper" });
    var hideInput = creator.createInput({ type: "checkbox", id: hideId });
    var hideLabel = creator.createLabel({
      htmlfor: hideId,
      text: "Ikke vis igjen",
    });

    inputWrapper.appendChild(hideInput);
    inputWrapper.appendChild(hideLabel);
    tipWin.appendChild(inputWrapper);
    $(hideInput).change(function (e) {
      if (e.currentTarget.checked) {
        localStorage.setItem("planinnsyn-" + hideId, true);
      } else {
        localStorage.removeItem("planinnsyn-" + hideId);
      }
    });
    if ($(article).find("section").length > 0) {
      $("#map").append(tipWin);
      if ($(tipWin).height() + 60 > $(window).height()) {
        $(article).css("height", $(window).height() - 140);
      }
    }
  },
};
//vindu for å returnere til fagsystem ved GI kall med hint
giHint = {
  lagOmraade: function (searchStr, sesjon, url2) {
    giHint.showHintWin("LagOmraade", url2, sesjon);
    let interactions = global.map.getInteractions();
    // Slår på måle-/tegneverktøy
    if (interactions.mapClickInteraction) {
      interactions.mapClickInteraction.setActive(false);
    }
    global.mapclick = false;

    var vector = global.map.getLayerByName("sketchLayer");
    var source = undefined;
    if (vector === null) {
      var style = new Style({
        stroke: new Stroke({
          color: "#ff0000",
          width: 3,
        }),
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: "rgba(255, 0, 0, 1)",
          }),
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.2)",
          }),
        }),
      });
      var source = new VectorWMS();
      var vector = new Vector({
        title: "sketchLayer",
        layerId: "sketchLayer",
        source: source,
        style: style,
        zIndex: 1000,
      });
      global.map.addLayer(vector);
    } else {
      source = vector.getSource();
    }
    var draw = new Draw({
      source: source,
      type: "Polygon",
    });
    draw.set("itype", "draw");
    draw.on("drawstart", function (event) {
      source.clear();
    });
    draw.on("drawend", function (event) {
      var feature = event.feature;
      var style = new Style({
        stroke: new Stroke({
          color: "rgba(255, 0, 0, 1)",
          width: 3,
        }),
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: "rgba(255, 0, 0, 1)",
          }),
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.2)",
          }),
        }),
      });
      feature.setStyle(style);
      feature.changed();
      let valueObject = {};
      valueObject.kodeverdi = "0301";
      valueObject.kodebeskrivelse = "OSLO";
      valueObject.coordinates = feature.getGeometry().flatCoordinates;
      document.getElementById("giReturnBtn").value =
        JSON.stringify(valueObject);
    });
    draw.set("interactionId", "pointSelect");
    global.map.addInteraction(draw);
  },
  lagPunkt: function (searchStr, sesjon, url2) {
    giHint.showHintWin("LagPunkt", url2, sesjon);
    let interactions = global.map.getInteractions();
    // Slår på måle-/tegneverktøy
    if (interactions.mapClickInteraction) {
      interactions.mapClickInteraction.setActive(false);
    }
    global.mapclick = false;
    global.pointclick = true;

    global.map.on("click", function (e) {
      if (global.pointclick) {
        document.getElementById("coordsCt").innerHTML = e.coordinate;
        let valueObject = {};
        valueObject.kodeverdi = "0301";
        valueObject.kodebeskrivelse = "OSLO";
        valueObject.x = e.coordinate[0];
        valueObject.y = e.coordinate[1];
        document.getElementById("giReturnBtn").value =
          JSON.stringify(valueObject);
        var clickFeature = new Feature({
          name: "clickFeature",
          geometry: new Point(e.coordinate),
        });
        clickFeature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 1],
              size: [32, 32],
              src: "icons/Kart PinBlue.png",
            }),
          }),
        );
        var markerlayer = global.map.getLayerById("fontmarkers");
        markerlayer.getSource().clear();
        markerlayer.getSource().addFeature(clickFeature);
      }
    });
  },
  lagDok: function (searchStr, sesjon, url2, hint) {
    dok.initiate(hint, searchStr, url2, sesjon);
  },
  lagEiendom: function (searchStr, sesjon, url2) {
    giHint.showHintWin("LagEiendom", url2, sesjon);
    let interactions = global.map.getInteractions();
    // Slår på måle-/tegneverktøy
    if (interactions.mapClickInteraction) {
      interactions.mapClickInteraction.setActive(false);
    }
    global.mapclick = false;
    global.pointclick = true;

    global.map.on("click", function (e) {
      if (global.pointclick) {
        $.ajax({
          url: encodeURI(
            "https://od2.pbe.oslo.kommune.no/kartinnsyn/kontekstmeny.php?e=" +
              Math.round(e.coordinate[0]) +
              "&n=" +
              Math.round(e.coordinate[1]),
          ),
          dataType: "json",
          success: function (data) {
            let eiendom = data[0];
            document.getElementById("giReturnBtn").value =
              JSON.stringify(eiendom);
            document.getElementById("coordsCt").innerHTML =
              eiendom.gnr + "/" + eiendom.bnr;
          },
          error: function (textStatus, jqXHR) {
            console.log(textStatus);
          },
        });

        var clickFeature = new Feature({
          name: "clickFeature",
          geometry: new Point(e.coordinate),
        });
        clickFeature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 1],
              size: [32, 32],
              src: "icons/Kart PinBlue.png",
            }),
          }),
        );
        var markerlayer = global.map.getLayerById("fontmarkers");
        markerlayer.getSource().clear();
        markerlayer.getSource().addFeature(clickFeature);
      }
    });
  },
  showHintWin: function (hint, url2, sesjon) {
    //var tipWin, btnWrapper, okBtn, inputWrapper, hideId = "", hideLabel, hideInput, article;

    var tipWin = creator.createDiv({ css: "tip-win" });

    var article = creator.createArticle({});
    article.appendChild(creator.createSection({ text: hint }));
    let coordsCt = creator.createDiv({ id: "coordsCt" });
    article.appendChild(coordsCt);
    let coordCheck = creator.createInput({
      id: "coordCheck",
      type: "checkbox",
    });
    coordCheck.onclick = giHint.coordCheckClick;
    coordCheck.checked = true;
    let coordCheckLabel = creator.createLabel({
      text: hint,
      htmlfor: "coordCheck",
    });
    article.appendChild(coordCheckLabel);
    article.appendChild(coordCheck);
    tipWin.appendChild(article);

    var btnWrapper = creator.createDiv({ css: "tip-win-btn-wrapper" });
    var okBtn = creator.createDiv({
      id: "giReturnBtn",
      text: "Lagre til sak <img src = './icons/lagre.svg' style='height:15px'/>",
      css: "btn btn-default",
    });
    okBtn.style.borderRadius = 0;
    okBtn.onclick = function () {
      $.ajax({
        url: encodeURI(
          "https://nfswstest.sesam.pbe.oslo.kommune.no:8443/giKartBasisLagre/lagre/?session=" +
            sesjon +
            "&hint=" +
            hint +
            "&data= " +
            okBtn.value,
        ),
        dataType: "json",
        success: function (data) {
          window.location.href = decodeURIComponent(url2);
        },
        error: function (textStatus, jqXHR) {
          console.log(textStatus);
        },
        complete: function (xhr, status) {
          window.location.href = decodeURIComponent(url2);
        },
      });
    };
    btnWrapper.appendChild(okBtn);
    tipWin.appendChild(btnWrapper);

    var inputWrapper = creator.createDiv({ css: "tip-win-input-wrapper" });
    inputWrapper.className = "tip-win-input-wrapper";

    tipWin.appendChild(inputWrapper);
    $("#map").append(tipWin);
    if ($(tipWin).height() + 60 > $(window).height()) {
      $(article).css("height", $(window).height() - 140);
    }
  },
  coordCheckClick: function () {
    let check = document.getElementById("coordCheck");
    let interactions = global.map.getInteractions();
    if (check.checked) {
      global.mapclick = false;
      global.pointclick = true;
      global.map.getInteractionById("pointSelect").setActive(true);
      if (interactions.mapClickInteraction) {
        interactions.mapClickInteraction.setActive(false);
      }
    } else {
      global.mapclick = true;
      global.pointclick = true;
      global.map.getInteractionById("pointSelect").setActive(false);
      if (interactions.mapClickInteraction) {
        interactions.mapClickInteraction.setActive(true);
      }
    }
  },
};

export default {
  createModule: function (allDom, conf) {
    /* Legger til kontekstspesifikke urler */
    var params = conf.parameters;
    var configs = conf.configs;
    global.GIFunctions.LagOmraade = giHint.lagOmraade;
    global.GIFunctions.LagPunkt = giHint.lagPunkt;
    global.GIFunctions.LagDok = giHint.lagDok;
    global.GIFunctions.LagEiendom = giHint.lagEiendom;

    Object.keys(params).forEach(function (p) {
      global[p] = params[p];
    });

    configs.modes.forEach(function (mode) {
      global.modes[mode.mode] = mode;
    });

    if (conf.intranett) {
      $(".user-message-intranett").show();
      var cssFile = document.createElement("link");
      cssFile.rel = "stylesheet";
      cssFile.href = "./css/intranett.css";
      document.head.appendChild(cssFile);
    } else {
      $(".user-message-internett").show();
    }
    if (configs.activeTip) {
      global.waitAndThen(
        2000,
        userTips.showTipWin,
        configs.tipText,
        configs.tipId,
      );
    }

    privateFns.setSiteAttributes(conf.site);
    mapFns.initiateMap(allDom.id, conf.configs);
    conf.loadplugins(
      global.map,
      function () {
        argParser.getTokenAndParams();
        if (params.intranett) {
          $(".user-message-intranett").show();
        } else {
          $(".user-message-internett").show();
        }
      },
      conf,
    );
    privateFns.setColorScheme(conf.configs.colorScheme);
  },
};
